import type { paths } from '@pba/types-openapi-node';
import type { ConfigRequest } from '@pba/utils';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';

type NodeEventsDataObject = paths['/events']['get']['responses']['200']['content']['application/json'];
type NodeEventsQueryRequestParams = paths['/events']['get']['parameters']['query'];

export const getNodeEvents = async ({ config }: ConfigRequest<NodeEventsQueryRequestParams>) =>
  nodeApiClient.get<NodeEventsDataObject, ApiClientResponse<NodeEventsDataObject>>(nodeApiRoutes.events.find, config);
